import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ManageSearchOutlined: typeof SvgIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path d="M7,9H2V7h5V9z M7,12H2v2h5V12z M20.59,19l-3.83-3.83C15.96,15.69,15.02,16,14,16c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5 c0,1.02-0.31,1.96-0.83,2.75L22,17.59L20.59,19z M17,11c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S17,12.65,17,11z M2,19h10v-2H2 V19z" />
        </SvgIcon>
    );
};
